export enum OwnershipListsName {
  TRADELIST = 'tradelist',
}
